document.addEventListener('DOMContentLoaded',()=>{
 document.querySelectorAll('form[data-sort]').forEach(form=>form.querySelector('select')?.addEventListener('change',()=>form.submit()));
 const header=document.querySelector('.gz-header'); if(!header) return;
 const nav=header.querySelector('#gz-navigation');
 const mobileToggle=header.querySelector('.gz-mobile-toggle');
 const catToggle=header.querySelector('.gz-main-category-link');
 const shell=header.querySelector('#gz-categories-panel');
 const items=Array.from(header.querySelectorAll('.gz-category-item'));
 const isDesktop=()=>window.matchMedia('(min-width: 801px)').matches;
 let active=-1;
 const adjustHeight=()=>{
   if(!shell || !isDesktop())return;
   const activePanel=items[active]?.querySelector('.gz-mega');
   if(!activePanel)return;
   const panelHeight=Math.ceil(activePanel.scrollHeight);
   shell.style.setProperty('--gz-mega-total-height',`${48+panelHeight}px`);
 };
 const setActive=(index)=>{
   if(index===active)return;
   active=index;
   items.forEach((item,i)=>{
     const b=item.querySelector('.gz-category-trigger');
     const p=item.querySelector('.gz-mega');
     const on=i===index;
     b?.setAttribute('aria-expanded',String(on));
     if(!p)return;
     if(isDesktop()){
       // Keep every panel mounted and measured, so switching never produces a flash or reflow.
       p.hidden=false;
       p.classList.toggle('gz-mega-current',on);
       p.setAttribute('aria-hidden',String(!on));
       if('inert' in p)p.inert=!on;
     }else{
       p.hidden=!on;
       p.classList.toggle('gz-mega-current',on);
       p.removeAttribute('aria-hidden');
       if('inert' in p)p.inert=false;
     }
   });
   adjustHeight();
 };
 const open=()=>{
   if(!shell)return;
   shell.hidden=false;
   catToggle?.setAttribute('aria-expanded','true');
   catToggle?.classList.add('gz-active');
   if(active<0)setActive(0);
   requestAnimationFrame(adjustHeight);
 };
 const close=()=>{
   if(!shell)return;
   shell.hidden=true;
   catToggle?.setAttribute('aria-expanded','false');
   catToggle?.classList.remove('gz-active');
 };
 items.forEach((item,i)=>{
   const b=item.querySelector('.gz-category-trigger');
   b?.addEventListener('mouseenter',()=>{if(isDesktop()){open();setActive(i)}});
   b?.addEventListener('focus',()=>{if(isDesktop()){open();setActive(i)}});
   b?.addEventListener('click',()=>{
     if(shell?.hidden)open();
     if(!isDesktop()&&active===i&&item.querySelector('.gz-mega')?.hidden===false){setActive(-1);return}
     setActive(i);
   });
 });
 catToggle?.addEventListener('click',()=>{if(shell?.hidden)open();else close()});
 // Open with click; hover is reserved for switching tabs, avoiding hover-click double toggle.
 mobileToggle?.addEventListener('click',()=>{
   const opened=!nav.classList.contains('gz-open');
   nav.classList.toggle('gz-open',opened);
   mobileToggle.setAttribute('aria-expanded',String(opened));
   if(!opened)close();
 });
 document.addEventListener('keydown',e=>{if(e.key==='Escape'){close();catToggle?.focus()}});
 document.addEventListener('pointerdown',e=>{if(!header.contains(e.target))close()});
 header.addEventListener('mouseleave',()=>{if(isDesktop())close()});
 window.addEventListener('resize',()=>{
   if(shell && !shell.hidden){
     // Reset panel states when switching between mobile and desktop CSS modes.
     const a=active;active=-1;setActive(a>=0?a:0);
     requestAnimationFrame(adjustHeight);
   }
 });
});
